import {Mapper} from '@s-ui/domain'

export class FromDealerEntityToStructuredDataValueObjectMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Function} deps.structuredDataValueObjectFactory
   * */
  constructor({config, structuredDataValueObjectFactory}) {
    super()
    this._config = config
    this._structuredDataValueObjectFactory = structuredDataValueObjectFactory
  }

  /**
   * https://schema.org/AutoDealer
   * @return {StructuredDataValueObject}
   */
  map = ({dealerEntity}) => {
    const dealer = dealerEntity.toJSON()
    const protocol = this._config.get('URL_PROTOCOL')
    const host = this._config.get('HOST_DOMAIN')

    const {name, location, stockPageUrl: canonicalPathName, storeImageUrls, phoneNumber} = dealer
    const {postalCode, address: streetAddress, city: addressLocality, coordinates} = location
    const [image] = storeImageUrls

    const dealerStructuredData = {
      '@context': 'http://schema.org',
      '@type': 'AutoDealer',
      name,
      address: {
        '@type': 'PostalAddress',
        streetAddress,
        postalCode,
        addressLocality
      },
      url: `${protocol}${host}${canonicalPathName}`,
      image,
      telephone: [phoneNumber]
    }

    const hasCoordinates = Boolean(coordinates)

    if (hasCoordinates) {
      const {lat: latitude, lng: longitude} = coordinates

      dealerStructuredData.geo = {
        '@type': 'GeoCoordinates',
        latitude,
        longitude
      }
    }

    return this._structuredDataValueObjectFactory(dealerStructuredData)
  }
}
